import { render } from "./DistributionView.vue?vue&type=template&id=25f09ada&scoped=true"
import script from "./DistributionView.vue?vue&type=script&lang=js"
export * from "./DistributionView.vue?vue&type=script&lang=js"

import "./DistributionView.vue?vue&type=style&index=0&id=25f09ada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f09ada"]])

export default __exports__